<template>
  <base-modal :box="box" :step="step" @on-back="mixin_set_init_step">
    <select-file-form v-model="form.params.media" :files.sync="files" />
    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save">
      {{ $t('pbx.worksheet.modal.action.child.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import SelectFileForm from '@autoinformer/components/worksheets/action-types/modals/_fragments/select-file-step';
  import { StepMixin } from '../../../_base/step-mixin';
  import { MediaService } from '@autoinformer/services/MediaService';

  export default {
    components: { BaseModal, SelectFileForm },
    mixins: [StepMixin],

    data() {
      return {
        is_loading: false,
        files: [],
        form: []
      };
    },

    created() {
      const campaign_id = this.$route.params.id;
      MediaService.getSelect(campaign_id).then(res => (this.files = res));
    },

    methods: {
      save: function() {
        this.mixin_save_step({
          params: {
            media: this.form.params.media
          }
        });
        this.mixin_set_init_step();
      }
    }
  };
</script>
